/* eslint-disable no-param-reassign */

import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import listSaga from './list';
import { BaseState, createCRUDModel, createCRUDStates } from '../creator';
import { RootState } from '../index';
import { PaginatedResponse } from '../types';
import { CategoryShort } from '../category';
import { SubCategory } from '../subCategory';
import { Option } from '../../types';

export const moduleName = 'statistic';

export type TipType = '%' | '$';
export const TipTypeOptions: Option<TipType>[] = [
  { label: '%', value: '%' },
  { label: '$', value: '$' },
];

export interface Statistic {
  id: string;
  tipType: TipType;
  group: string;
  statistic: CategoryShort;
  subCategory: SubCategory;
  data: {
    data: {
      statisticByWorker?: {
        count: number;
        avgValue: number;
        medianValue: number;
      },
      statisticByUser?: {
        count: number;
        avgValue: number;
        medianValue: number;
      }
    };
    params: {
      tipType: TipType;
      maxValue: number;
      minValue: number;
    }
  }[];
  updatedAt: string;
}

export interface State {
  list: BaseState<PaginatedResponse<Statistic>>
}

const models = ['list'];

export const defaultState: State = createCRUDStates<State>(models);

export const statistic = createSlice({
  name: moduleName,
  initialState: defaultState,
  reducers: createCRUDModel(models, moduleName),
});

export const { actions } = statistic;

export function useStatistic(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export function* saga() {
  yield* listSaga();
}
